import {
  subheading2
}
  from '_utils/styles/';


export default {
  descriptionSize: subheading2
};
